import React from "react";
import styled from "styled-components";
import Icons from "../../../Icons";
import Badge from "../../../Badge";
import ProjectTitle from "../ProjectTitle";
import ProjectSection from "../ProjectSection";
import ProjectSectionSkills from "../ProjectSectionSkills";
import ProjectDescription from "../ProjectDescription";
import ProjectHeroImage from "../ProjectHeroImage";
import NgaImage from "../../../../img/nga.jpg";
import NgaBG from "../../../../img/ww2.webp";

const NgaProjectSection = styled(ProjectSection)`


  background: linear-gradient(
      #009691e3
    ),
    url("${NgaBG}");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;

`;

function Nga() {
  return (
    <NgaProjectSection>
      <ProjectTitle title="Ngā Taonga" tag="2015" />

      <ProjectSectionSkills>
        <Badge small title="UI Design">
          <Icons type="rgba-small" />
        </Badge>
        <Badge small title="HTML">
          <Icons type="html-small" />
        </Badge>
        <Badge small title="Sass">
          <Icons type="sass-small" />
        </Badge>
        <Badge small title="Agile Process">
          <Icons type="agile-small" />
        </Badge>
        <Badge small title="UX Design">
          <Icons type="ux-small" />
        </Badge>
      </ProjectSectionSkills>
      <ProjectDescription>
        I lead the design & front-end to build a deserving mobile-first experience, which complements the vibrant
        content found within the walls at Ngā Taonga Sound & Vision.
      </ProjectDescription>

      <ProjectHeroImage src={NgaImage} desktop lazy />
    </NgaProjectSection>
  );
}

export default Nga;
